// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Muster aus kraftbogen (ohne BottomNav — fitHub nutzt die Pill-TabNav im Layout).
// Wer noch mit dem Startpasswort des Admins unterwegs ist, kommt nur auf die
// Passwort-setzen-Seite (Runde 13).
import { Navigate } from "react-router-dom"
import { isAuthed } from "@/lib/auth"
import { mussPasswortAendern } from "@/lib/mitglieder"
import Layout from "@/components/Layout"

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  if (!isAuthed()) return <Navigate to="/login" replace />
  if (mussPasswortAendern()) return <Navigate to="/passwort-setzen" replace />
  return <Layout>{children}</Layout>
}
